export const RESET_RESERVATION_ISFETCHING = 'RESET_RESERVATION_ISFETCHING';
export const GET_RESERVATION_REQUEST = 'GET_RESERVATION_REQUEST';
export const GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST =
  'GET_RESERVATION_BY_EMAIL_RESERVATIONNUMBER_REQUEST';
export const GET_RESERVATION_SUCCESS = 'GET_RESERVATION_SUCCESS';
export const LIST_RESERVATIONS_REQUEST = 'LIST_RESERVATIONS_REQUEST';
export const LIST_RESERVATIONS_SUCCESS = 'LIST_RESERVATIONS_SUCCESS';
export const RESERVATION_REQUESTING = 'RESERVATION_REQUESTING';
export const RESET_RESERVATION_QUERY = 'RESET_RESERVATION_QUERY';
